import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const colorMap = theme => ({
  primary: {
    backgroundColor: theme.customColors.blue[200],
    color: theme.customColors.blue[500]
  },
  secondary: {
    backgroundColor: theme.customColors.purple[300],
    color: theme.customColors.purple[600]
  },
  info: {
    backgroundColor: theme.customColors.grey[300],
    color: theme.customColors.grey[600]
  },
  success: {
    backgroundColor: '#DFFFE6',
    color: theme.customColors.green[500]
  },
  error: {
    backgroundColor: theme.customColors.pink[100],
    color: theme.customColors.pink[600]
  },
  warning: {
    backgroundColor: theme.customColors.yellow[300],
    color: theme.customColors.yellow[600]
  }
});
const StyledStatusLabel = /*#__PURE__*/_styled('div', {
  shouldForwardProp: isStyledPropsValid,
  target: "e1u3y33i0"
})(_ref => {
  let {
    theme,
    size = 'small',
    color = 'primary',
    onClick = null
  } = _ref;
  return _objectSpread2(_objectSpread2(_objectSpread2({}, colorMap(theme)[color]), size === 'small' && {
    fontSize: '12px',
    padding: '2.5px 4px',
    height: '20px',
    borderRadius: '15px',
    display: 'inline-flex',
    alignItems: 'center'
  }), onClick && {
    cursor: 'pointer'
  });
}, "");
export { StyledStatusLabel };